import React, { useState } from 'react'
import { useSelector } from 'react-redux'

const STORAGE_KEY = 'partner_banner_dismissed'

const bannerStyle = {
    background: 'var(--color-background-info, #e0f2fe)',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    fontSize: '14px',
    color: '#0c4a6e',
    boxSizing: 'border-box',
    flexShrink: 0,
    width: '100%'
}

const ctaButtonStyle = {
    background: '#0e7490',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '6px 16px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'none',
    lineHeight: '1.5',
    whiteSpace: 'nowrap'
}

const dismissButtonStyle = {
    background: 'transparent',
    border: 'none',
    color: '#0c4a6e',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '4px 8px',
    lineHeight: '1',
    opacity: '0.6',
    marginLeft: '4px'
}

const actionsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0
}

const PartnerBanner = () => {
    const [dismissed, setDismissed] = useState(
        () => Boolean(sessionStorage.getItem(STORAGE_KEY))
    )

    const user = useSelector(state => state.Auth?.profile?.user)

    const handleDismiss = () => {
        sessionStorage.setItem(STORAGE_KEY, '1')
        setDismissed(true)
    }

    if (dismissed || !user) return null

    const ctaUrl =
        `https://timbrat.com.mx/para-contadores` +
        `?ref=contador_partner` +
        `&email=${encodeURIComponent(user.email)}` +
        `&uid=${user._id}`

    return (
        <div style={bannerStyle}>
            <span>
                ¿Facturas para varios clientes? Únete al programa de socios de Timbrát y genera ingresos extra.
            </span>
            <div style={actionsStyle}>
                <a
                    href={ctaUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={ctaButtonStyle}
                >
                    Quiero ser socio
                </a>
                <button
                    onClick={handleDismiss}
                    aria-label="Cerrar"
                    style={dismissButtonStyle}
                >
                    ✕
                </button>
            </div>
        </div>
    )
}

export default PartnerBanner
